import { Box } from "@mui/material";

export const TreeLine = ({
  isLast,
  left,
  width,
}: {
  isLast: boolean;
  left: number;
  width: number | string;
}) => (
  <Box
    sx={{
      position: "relative",
      alignSelf: "stretch",
      flex: "none",
      width,
      "&::before": {
        content: '""',
        position: "absolute",
        left,
        top: 0,
        bottom: isLast ? "50%" : 0,
        borderLeft: 2,
        borderColor: "grey.200",
      },
      "&::after": {
        content: '""',
        position: "absolute",
        left,
        top: "50%",
        width: 12,
        borderTop: 2,
        borderColor: "grey.200",
      },
    }}
  />
);
